<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-input v-model="formDatas.akwName" style="width: 140px;" size="small" placeholder="请输入名称"
                        clearable></el-input>
                    <el-button type="info" size="small" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                    <!-- <el-button type="danger" size="small" style="margin-left: 10px" @click="BulkDelete">批量删除</el-button> -->
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <el-button type="success" size="small" style="margin-right: 20px" @click="BoxOpen">新增知识库</el-button>

                    <!-- <el-button type="warning" size="small" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                        row-key-field-name="akwId" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                        :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 新增 -->
            <el-drawer :wrapperClosable="false" :title="edit == true ? '编辑知识库' : '新增知识库'" :before-close="handleClose"
                :visible.sync="dialog" direction="rtl" custom-class="demo-drawer" ref="drawer">
                <div class="demo-drawer__content" style="height: 90%;">
                    <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
                        <div
                            style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                            <el-form-item label="知识库名称" prop="akwName">
                                <el-input v-model="form.akwName" style="width: 50%;" placeholder="请输入名称"></el-input>
                            </el-form-item>
                            <el-form-item label="知识库描述" prop="akwDes">
                                <el-input v-model="form.akwDes" style="width: 50%;" placeholder="请输入名称"></el-input>
                            </el-form-item>
                            <el-form-item label="知识库分类" prop="akcId">
                                <el-select v-model="form.akcId" placeholder="请选择">
                                    <el-option v-for="item in akcName_arr || []" :label="item.akcName"
                                        :value="item.akcId" :key="item.akcId">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="demo-drawer__footer" style="margin-top: 10px;">
                    <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">
                        确 定</el-button>
                </div>
            </el-drawer>
            <!-- 文件列表-->
            <el-dialog title="知识库文件" :visible.sync="isFileList" width="70%" top="8vh">
                <div style="width: 100%;display: flex;flex-direction: row-reverse;margin: 15px auto;">
                    <el-button type="success" size="small" style="margin-right: 20px"
                        @click="addFiles">多文件上传</el-button>
                    <el-button type="success" size="small" style="margin-right: 20px" @click="addFile">单文件上传</el-button>
                </div>

                <div>
                    <ve-table ref="vetable2" v-if="tableDataFile" :columns="columnsFile" :table-data="tableDataFile"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                        row-key-field-name="akfId" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                        :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
            </el-dialog>
            <!-- 上传文件-->
            <el-dialog title="知识库文件" :visible.sync="isFlieAdd" width="70%" top="8vh">
                <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
                    <div
                        style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                        <el-form-item label="上传文件" prop="akfPath">
                            <my-uploadVideo ref="upload" @fileChange="FileChange" :filearr="fileList" :limit="1"
                                style="margin: 10px 5px 5px;" @removeAfter="formFile.akfPath = ''" type="text">
                            </my-uploadVideo>
                        </el-form-item>
                        <el-form-item label="文件名称" prop="akfName">
                            <el-input v-model="formFile.akfName" style="width: 50%;" placeholder="请输入名称"></el-input>
                        </el-form-item>
                    </div>
                </el-form>
                <div class="demo-drawer__footer" style="margin-top: 10px;">
                    <el-button @click="handleClose2()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="SureBtn2" style="margin-left: 150px;">
                        确 定</el-button>
                </div>
            </el-dialog>
            <!-- 多上传文件-->
            <el-dialog title="知识库上传多文件" :visible.sync="isFliesAdd" width="70%" top="8vh">
                <el-form ref="formRefFiles" :model="formFiles" label-position="top" :rules="rules" style="height:100%">
                    <div
                        style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                        <el-form-item label="上传多文件">
                            <my-uploadVideo ref="upload2" @fileChange="FileChange2" :filearr="fileList2" :limit="99"
                                style="margin: 10px 5px 5px;" @removeAfter="removeAfter" type="text">
                            </my-uploadVideo>
                        </el-form-item>
                        <div>文件列表:</div>
                        <el-table :data="fileListData" stripe border style="width: 100%" :max-height="300"
                            :cell-style="{ textAlign: 'center' }" :header-cell-style="{
                                textAlign: 'center',
                                background: 'rgba(0,170,255,0.5)',
                                color: 'black',
                                border: 'none',
                            }">
                            <el-table-column prop="akfName" label="文件名称">
                            </el-table-column>
                            <el-table-column prop="akfPath" label="文件地址">
                            </el-table-column>
                        </el-table>
                        <div v-if="fail_fileListData.length > 0">上传失败的文件列表:</div>
                        <el-table v-if="fail_fileListData.length > 0" :data="fail_fileListData" stripe border
                            style="width: 100%" :max-height="300" :cell-style="{ textAlign: 'center' }"
                            :header-cell-style="{
                                textAlign: 'center',
                                background: 'rgba(0,170,255,0.5)',
                                color: 'black',
                                border: 'none',
                            }">
                            <el-table-column prop="akfName" label="文件名称">
                            </el-table-column>
                            <el-table-column prop="akfPath" label="文件地址">
                            </el-table-column>
                            <el-table-column prop="des" label="失败原因">
                            </el-table-column>
                        </el-table>
                    </div>
                </el-form>
                <div class="demo-drawer__footer" style="margin-top: 10px;">
                    <el-button @click="handleCloseFiles()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="SureBtnFiles" style="margin-left: 150px;">
                        确 定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>

import {
    getAiKnowledgeWareList, addAiKnowledgeWare, updateAiKnowledgeWare, deleteAiKnowledgeWare, getAiKnowledgeClassList, getAiKnowledgeFileList,
    updateAiKnowledgeFile, addAiKnowledgeFile, deleteAiKnowledgeFile, addAiKnowledgeFileMulti

} from "../../api/api";
let Base64 = require("js-base64").Base64;
export default {
    name: "",
    components: {},
    data() {
        return {
            fail_fileListData: [],
            formFiles: {},
            fileListData: [],
            fileList2: [],
            isFliesAdd: false,
            isFlieAdd: false,
            formFile: {
                akfName: '',
                akfPath: ''
            },
            fileList: [],
            tableDataFile: [],
            isFileList: false,
            theItem: {},
            akcName_arr: [],
            OtherImgfileList: [],
            key: 'akwId',
            dialog: false,
            edit: false,
            form: {
                akwName: '',
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            columnsFile: [
                // {
                //     field: "",
                //     key: "checkbox",
                //     // type=checkbox
                //     type: "checkbox",

                //     title: "",
                //     width: 50,
                //     align: "center",
                // },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "akfName",
                    key: "akfName",
                    title: "文件名称",
                    align: "center",
                    edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    <el-tag>{row.akfName}</el-tag>
                                }
                            </span>
                        )
                    },
                },
                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 200,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {row.akfPath ? (
                                    <el-button
                                        size="mini"
                                        type="text"
                                        on-click={() =>
                                            this.downloadFile(row.akfPath, row.akfName)
                                        }
                                    >
                                        下载
                                    </el-button>
                                ) : (
                                    ""
                                )}
                                <el-button
                                    size="mini"
                                    type="text"
                                    on-click={() => this.handleEdit2(row)}
                                >
                                    编辑
                                </el-button>
                                <el-button
                                    size="mini"
                                    type="text"
                                    style="color: red"
                                    on-click={() => this.handleDelete2(row)}
                                >
                                    删除
                                </el-button>
                            </span>
                        );
                    },
                },
            ], //表格的列
            columns: [
                {
                    field: "",
                    key: "checkbox",
                    // type=checkbox
                    type: "checkbox",

                    title: "",
                    width: 50,
                    align: "center",
                },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "akwName",
                    key: "akwName",
                    title: "知识库名称",
                    align: "center",
                    edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    <el-tag>{row.akwName}</el-tag>
                                }
                            </span>
                        )
                    },
                },
                { field: "akcName", key: "akcName", title: "知识库分类", width: 120, align: "center" },
                { field: "akwDes", key: "akwDes", title: "知识库描述", width: 120, align: "center" },
                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 200,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"
                                    on-click={() => this.openFileList(row)}
                                >
                                    文件列表
                                </el-button>
                                <el-button
                                    size="mini"
                                    type="text"
                                    on-click={() => this.handleEdit(row)}
                                >
                                    编辑
                                </el-button>
                                <el-button
                                    size="mini"
                                    type="text"
                                    style="color: red"
                                    on-click={() => this.handleDelete(row)}
                                >
                                    删除
                                </el-button>
                            </span>
                        );
                    },
                },
            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                appiType: 1,
                akwName: '',
                currentPage: 1,
                pageSize: 10,
            },
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        getAiKnowledgeClassList({ pageSize: 0 }).then(res => {
            this.akcName_arr = res.data
        })
        this.getList();
    },
    mounted() { },
    methods: {
        downloadFile(url, name) {
            //下载
            if (!url) {
                return;
            }
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.onload = function () {
                document.body.removeChild(link);
            };
            link.setAttribute("download", name);
            document.body.appendChild(link);
            link.click();
        },
        removeAfter(index) {
            this.fileListData.splice(index, 1);
        },
        handleDelete2(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    deleteAiKnowledgeFile({ akfId: row.akfId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.getList2()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit2(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.isFlieAdd = true;
            this.edit = true;
            this.$nextTick(() => {
                this.formFile = data;
                this.formFile.akfPath = data.akfPath.split(',')
                if (this.form.akfPath && this.form.akfPath.length > 0) {
                    this.form.akfPath.forEach((item, index) => {
                        const img = {
                            name: item,
                            url: item,
                        }
                        this.$set(this.fileList, index, img);
                    })

                }
            })
        },
        SureBtn2() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        const data = JSON.parse(JSON.stringify(this.formFile))
                        data.akwId = this.theItem.akwId
                        addAiKnowledgeFile(data).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose2()
                                this.getList2()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        const data = JSON.parse(JSON.stringify(this.formFile))
                        data.akwId = this.theItem.akwId
                        updateAiKnowledgeFile(data).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose2()
                                this.getList2()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        addFile() {
            this.isFlieAdd = true;
            this.$nextTick(() => {
                this.formFile.akfPath = ''
                this.fileList = []
            })
        },
        addFiles() {
            this.isFliesAdd = true;
            this.$nextTick(() => {
                this.fileListData = [];
                this.fileList2 = []
            })
        },
        FileChange2(file) {
            console.log(file);
            this.fileListData = [];
            if (file.length > 0) {
                file.forEach((item, index) => {
                    const img = {
                        akfName: item.fileName,
                        akfPath: item.fileurl,
                    }
                    this.fileListData.push(img)
                })
            } else {
                this.$message({
                    type: "error",
                    message: "上传失败!",
                });
            }
        },
        FileChange(file) {
            console.log(file);
            if (file.length > 0) {
                this.$set(this.formFile, 'akfPath', file[0].fileurl)
                this.$set(this.formFile, 'akfName', file[0].fileName)
                this.$message({
                    type: "success",
                    message: "上传成功!",
                });
            } else {
                this.$message({
                    type: "error",
                    message: "上传失败!",
                });
            }

        },
        handleClose2() {
            this.isFlieAdd = false;
            this.$refs['formRef'].resetFields();
            this.fileList = []
            this.edit = false;
        },

        getList2() {
            getAiKnowledgeFileList({ akwId: this.theItem.akwId }).then((res) => {
                this.tableDataFile = res.data;
                this.totalCount = res.total;
            });
        },
        openFileList(row) {
            getAiKnowledgeFileList({ akwId: row.akwId }).then(res => {
                this.tableDataFile = res.data
                this.theItem = row;
                this.isFileList = true;
            })

        },
        OtherImgChange(file) {
            console.log(file);
            this.$set(this.form, 'aaIcon', file[0].url)
            this.$message({
                type: "success",
                message: "上传成功!",
            });
        },
        // 批量删除
        BulkDelete() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0) {
                this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        deleteAiKnowledgeWare({ akwIds: this.selectedRowKeysCollection.toString() }).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "删除成功!",
                                });

                                this.partserch()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }
        },
        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {

                    deleteAiKnowledgeWare({ akwId: row.akwId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
                this.form.aaIcon = data.aaIcon.split(',')
                console.log(this.form.aaIcon);
                if (this.form.aaIcon && this.form.aaIcon.length > 0) {
                    this.form.aaIcon.forEach((item, index) => {
                        const img = {
                            name: item,
                            url: item,
                        }
                        this.$set(this.OtherImgfileList, index, img);
                        console.log(this.OtherImgfileList);

                    })

                }
            })
        },
        SureBtnFiles() {
            this.$confirm("是否确定要批量新增文件, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    const newForm = JSON.parse(JSON.stringify(this.formFiles));
                    newForm.akwId = this.theItem.akwId
                    newForm.akfNameMulti = this.fileListData.length > 0 ? JSON.stringify(this.fileListData) : ''
                    addAiKnowledgeFileMulti(newForm).then(res => {
                        if (res.data.length == 0) {
                            this.$message({
                                type: "success",
                                message: "新增成功!",
                            });
                            this.handleCloseFiles()
                            this.getList2()
                        } else if (res.data.length > 0) {
                            this.$message({
                                type: "danger",
                                message: "有部分文件上传失败!",
                            });
                            this.fileList2 = [];
                            this.fileListData = [];
                            this.formFiles = {
                                akwId: this.theItem.akwId,
                                akfNameMulti: '',
                            }
                            this.fail_fileListData = res.data;

                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        addAiKnowledgeWare(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        updateAiKnowledgeWare(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
            this.OtherImgfileList = [];
        },
        // 关闭弹框
        handleCloseFiles() {
            this.isFliesAdd = false;
            this.$refs['formRefFiles'].resetFields();
            this.fileList2 = [];
            this.fileListData = [];
            this.fail_fileListData = [];
            this.formFiles = {
                akfNameMulti: '',
                akwId: '',
            }
        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.akwId = row.akwId
                    console.log(jsonObj);
                    updateAiKnowledgeWare(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item[key]), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {

            const rowKey = row[key];

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getAiKnowledgeWareList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getAiKnowledgeWareList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        getList() {
            getAiKnowledgeWareList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>